import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useOnboarding } from '../../data/useOnboarding';
import { HOME_WORDING as W } from '../../domain/home';
import s from './GettingStarted.module.css';

// The getting-started row.
//
// The whole of onboarding: at the top of Home, dismissible, and it never
// blocks anything — a teacher who wants to go straight to the calendar can.
//
// Each incomplete step links into the real create flow rather than a bespoke
// onboarding screen, so there is exactly one "add a student" path in the product
// and it is the same one a teacher uses in year three.

function CheckIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
      <path d="M2.5 7.5l3 3 6-6.5" stroke="currentColor" strokeWidth="2"
            strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export default function GettingStarted() {
  const { milestones, visible, dismiss } = useOnboarding();
  const navigate = useNavigate();

  if (!visible) return null;

  return (
    <>

      <section className={s.panel} aria-label={W.checklistLabel}>
        <button className={s.dismiss} onClick={dismiss} aria-label={W.dismissChecklist}>
          <svg width="14" height="14" viewBox="0 0 14 14" aria-hidden="true">
            <path d="M3 3l8 8M11 3l-8 8" stroke="currentColor" strokeWidth="1.75"
                  strokeLinecap="round" />
          </svg>
        </button>

        <div className={s.steps}>
          {milestones.map((m, i) => {
            const actionable = !m.complete && m.href;
            const Tag = actionable ? 'button' : 'div';
            // A connector is hidden at the ends of the row rather than omitted,
            // so every node sits at the same x within its column.
            const before = i === 0 ? s.lineHidden : m.complete ? s.lineFilled : s.line;
            const after = i === milestones.length - 1 ? s.lineHidden
              : (m.complete && milestones[i + 1]?.complete) ? s.lineFilled : s.line;
            return (
              <Tag
                key={m.id}
                className={actionable ? s.stepActionable : s.step}
                onClick={actionable ? () => navigate(m.href) : undefined}
                type={actionable ? 'button' : undefined}
              >
                <div className={s.row}>
                  <div className={before} />
                  <div className={m.complete ? s.nodeComplete : m.current ? s.nodeCurrent : s.node}>
                    {m.complete ? <CheckIcon /> : i + 1}
                  </div>
                  <div className={after} />
                </div>
                <span className={m.complete || m.current ? s.labelActive : s.label}>
                  {m.label}
                </span>
              </Tag>
            );
          })}
        </div>
      </section>
    </>
  );
}
